import { createContext, useContext, useEffect, useState } from "react";
import { login as loginApi, logout as logoutApi, getProfile } from "../Services/authService";
import permissionsService from "../Services/permissionsService";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      try {
        if (localStorage.getItem("auth_token")) {
          const me = await getProfile();
          setUser(me);
        }
      } catch {
        setUser(null);
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  const login = async (email, password) => {
    await loginApi(email, password);
    const me = await getProfile();
    setUser(me);
  };

  const logout = () => {
    logoutApi();
    setUser(null);
  };

  // Créer un objet user enrichi avec les méthodes de permissions
  const enrichedUser = user ? {
    ...user,
    // Méthodes de permissions
    hasPermission: (resource, action) => permissionsService.hasPermission(user, resource, action),
    canManage: (resource) => permissionsService.canManage(user, resource),
    isCollaborateur: () => permissionsService.isCollaborateur(user),
    isClient: () => permissionsService.isClient(user),
    isAdmin: () => permissionsService.isAdmin(user),
    isManager: () => permissionsService.isManager(user),
    isTechnicien: () => permissionsService.isTechnicien(user),
    canViewMonitoring: () => permissionsService.canViewMonitoring(user),
    canManageUsers: () => permissionsService.canManageUsers(user),
    canManageClients: () => permissionsService.canManageClients(user),
    canManageContacts: () => permissionsService.canManageContacts(user),
    canManageCollaborateurs: () => permissionsService.canManageCollaborateurs(user),
    canViewTickets: () => permissionsService.canViewTickets(user),
    canCreateTickets: () => permissionsService.canCreateTickets(user),
    canEditTickets: () => permissionsService.canEditTickets(user),
    canDeleteTickets: () => permissionsService.canDeleteTickets(user),
    canChangeTicketStatus: () => permissionsService.canChangeTicketStatus(user),
    canAssignTickets: () => permissionsService.canAssignTickets(user),
    getBackendRole: () => permissionsService.getUserBackendRole(user),
    getSymfonyRole: () => permissionsService.getUserSymfonyRole(user),
    getAllPermissions: () => permissionsService.getAllPermissions(user)
  } : null;

  return (
    <AuthContext.Provider value={{ user: enrichedUser, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
} 